import styled from 'styled-components';

export const BasketCircle = styled.div<{ darkTheme?: boolean }>`
  width: 15px;
  height: 15px;
  position: absolute;
  top: -5px;
  right: -5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.palette.R600};

  & {
    color: ${({ theme }) => theme.palette.white};
  }
`;
